import { isFuture } from 'date-fns';


export function isNotFutureDate(val: string) {
    return isFuture(new Date(val)) ? 'Date cannot be in the future' : true;
}
